{
    "name": "rise-of-the-blobs",
    "version": "0.5.8",
    "main": "js/index.js",
    "type": "module",
    "module": "js/index.js",
    "scripts": {
        "assets": "assetpack",
        "encode-json": "node ./scripts/cbor-encode.js raw-assets/data static/data",
        "deploy": "wl-cloud page update --config ./deployment.json --skipConfigUpdate --noThreads",
        "deploy:staging": "wl-cloud page update --config ./deployment-staging.json --skipConfigUpdate --noThreads",
        "deploy:crazygames": "wl-cloud page update --config ./deployment-crazygames.json --skipConfigUpdate --noThreads",
        "deploy:telegram": "wl-cloud page update --config ./deployment-telegram.json --skipConfigUpdate --noThreads",
        "format": "prettier --write \"**/*.{js,jsx,ts,tsx,json,css,md}\"",
        "build:plugin": "node esbuild-plugins.mjs",
        "build:plugin:watch": "node esbuild-plugins.mjs --watch"
    },
    "prettier": "@wonderlandengine/prettier-config",
    "keywords": [
        "wonderland-engine"
    ],
    "overrides": {
        "@wonderlandengine/api": "$@wonderlandengine/api"
    },
    "dependencies": {
        "@wonderlandengine/api": "^1.4.7",
        "@wonderlandengine/components": "^1.1.5",
        "@wonderlandengine/react-ui": "file:lib/wonderlandengine-react-ui-0.2.12.tgz",
        "@wonderlandengine/spatial-audio": "1.2.4",
        "@wonderlandengine/tweenjs": "file:lib/wonderlandengine-tweenjs-0.0.4.tgz",
        "@wonderlandengine/upsdk": "^0.2.1",
        "@wonderlandengine/upsdk-provider-cookie": "^0.1.1",
        "@wonderlandengine/upsdk-provider-crazygames": "^0.1.1",
        "@wonderlandengine/upsdk-provider-localstorage": "^0.1.1",
        "@wonderlandengine/upsdk-provider-poki": "^0.1.1",
        "@wonderlandengine/upsdk-provider-telegram": "^0.1.2",
        "gameanalytics": "^4.4.7",
        "gl-matrix": "^3.4.3",
        "uuid": "^11.0.3"
    },
    "devDependencies": {
        "@assetpack/core": "^1.1.1",
        "@wonderlandengine/editor-api": "^1.2.4",
        "@wonderlandengine/prettier-config": "^1.0.0",
        "cbor2": "^1.12.0",
        "esbuild": "^0.24.2",
        "glob": "^11.0.2",
        "prettier": "^3.3.3",
        "typescript": "^4.9.3"
    }
}
